import getMessageErrorUtil from '../../utils/get-message'
import { logUtil } from 'packages/src'
// import getStringifiedPropertiesObjectUtil from '../../../../utils/object/get-stringified-properties'
// import * as Sentry from '../../../../sentry-expo'
// const Sentry = {}

function sendErrorAction (error) {
  return () => {
    logUtil('').error('[sendErrorAction] an error occurred: ', error)
    const message = getMessageErrorUtil(error)
    // const reduxStateStr = JSON.stringify(getStringifiedPropertiesObjectUtil(pickObjectUtil(
    //   getState(),
    //   [
    //     APP_DOMAIN,
    //     PROFILES_DOMAIN,
    //     USERS_DOMAIN,
    //     WORKOUTS_DOMAIN,
    //     PLANS_DOMAIN
    //   ]
    // )))
    if (!(
      error instanceof Error
    )) {
      error = new Error(message)
    }

    // Sentry.Native.captureException(error, {
    //   extra: {
    //     // Add the reduxState to the event, there is a size limit
    //     // @see {@link
    //     // https://github.com/getsentry/sentry-javascript/issues/339}
    //     reduxState: reduxStateStr.slice(0, 60000)
    //   }
    // })
  }
}

export default sendErrorAction
